import { render } from "./Calendar.vue?vue&type=template&id=513683a6&scoped=true"
import script from "./Calendar.vue?vue&type=script&lang=js"
export * from "./Calendar.vue?vue&type=script&lang=js"

import "./Calendar.vue?vue&type=style&index=0&id=513683a6&scoped=true&lang=scss"

import exportComponent from "/Users/davidolmos/Desktop/vue3-daterange-picker/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-513683a6"]])

export default __exports__